/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { SupportPlanPost } from './support-plan.post';

const Params = z.strictObject({ supportPlanId: ZodTypes.Id });

export const SupportPlanPatch = {
  id: 'support-plan.patch',
  tag: 'Common',
  summary: 'Patch support plan',
  description: 'Update a support plan',
  method: 'patch',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/support-plans/${params.supportPlanId}`,
  request: {
    params: Params,
    body: SupportPlanPost.request.body,
  },
  response: SupportPlanPost.response,
} as const satisfies Endpoint;
